<template>
  <div :class="{item: true, hasImg: hasImg, active: active}" :data-state="state" @click="onSetCoupon">
    <div v-if="hasImg" :style="setStyle" class="thumb"></div>
    <div class="text">
      <p class="title">{{item.title}}</p>
      <p v-if="payload.useTerm" class="date">
        <span class="from">{{displayDate(item.useAfter)}}</span> ~
        <span class="to">{{displayDate(item.useBefore)}}</span>
      <p v-else class="date">{{locale.coupon_use_always}}</p>
    </div>
  </div>
</template>

<script>
import DATE from '@/common/date'
import moment from 'moment/moment'

export default {
  name: 'CouponItem',
  props: [
    'locale',
    'item',
    'isActive'
  ],
  computed: {
    ln () {
      return this.$store.state.coupon.preview.lang
    },
    state () {
      /**
       * 00 : 기간 종료
       * 01 : 사용 가능
       * 02 : 종료 임박 (7일 전)
       */
      const diff = moment().diff(this.item.useBefore, 'days')
      if (diff > 0) {
        return '00'
      } else {
        if (diff < -7) {
          return '01'
        } else {
          return '02'
        }
      }
    },
    activeCoupon () {
      return this.$store.getters['coupon/getSetInfo']
    },
    payload () {
      const setPayload = typeof (this.item.payload) === 'string' ? JSON.parse(this.item.payload) : this.item.payload
      return typeof (setPayload) === 'undefined' ? this.$store.state.coupon.setInfo.payload : setPayload
    },
    hasImg () {
      return this.item.payload.image !== null
    },
    /**
     * 현재는 이미지만 있지만
     * 추후에 다른 스타일이 들어올 수도 있기 때문에 스타일 바인딩해줌
     * 스킨도 몇가지 고려중
     */
    setStyle () {
      let styleObj = {}
      if (this.hasImg) {
        styleObj['background-image'] = `url('${this.payload.image}')`
      }
      return styleObj
    }
  },
  watch: {
    isActive (isActive) {
      if (!isActive) {
        this.active = false
      }
    },
    activeCoupon: {
      deep: true,
      handler (coupon) {
        this.active = coupon.cid === this.item.cid
      }
    }
  },
  data () {
    return {
      active: false
    }
  },
  methods: {
    displayDate (date) {
      return DATE.toString(date)
    },
    onSetCoupon () {
      this.$emit('getItem')
      const couponData = {
        cid: this.item.cid,
        title: this.item.title,
        category: this.item.category,
        useAfter: this.item.useAfter,
        useBefore: this.item.useBefore,
        payload: this.payload
      }
      this.$store.commit('coupon/setCouponInfo', couponData)
    }
  }
}
</script>

<style lang="scss" scoped>
[data-state="00"] {
  .date {
    color: $color-grey;
  }
}
[data-state="01"] {
  .date {
    color: $color-blue;
  }
}
[data-state="02"] {
  .date {
    color: $color-red;
  }
}
</style>
